/**
 * @generated SignedSource<<a2c9dc099d3b7d79cd74bd591996a945>>
 * @relayHash f5bf042c501578b47d326c7288427026
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ui_projectSettingsToolchainQuery$variables = {
  cloudId: string;
};
export type ui_projectSettingsToolchainQuery$data = {
  readonly dvcs: {
    readonly bitbucketWorkspacesLinkedToSite: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "DvcsBitbucketWorkspaceEdge";
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ui_projectSettingsToolchainQuery = {
  response: ui_projectSettingsToolchainQuery$data;
  variables: ui_projectSettingsToolchainQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "concreteType": "DvcsQuery",
    "kind": "LinkedField",
    "name": "dvcs",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Literal",
            "name": "first",
            "value": 1
          }
        ],
        "concreteType": "DvcsBitbucketWorkspaceConnection",
        "kind": "LinkedField",
        "name": "bitbucketWorkspacesLinkedToSite",
        "plural": false,
        "selections": [
          {
            "concreteType": "DvcsBitbucketWorkspaceEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_projectSettingsToolchainQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_projectSettingsToolchainQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409",
    "metadata": {},
    "name": "ui_projectSettingsToolchainQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "190735208b3c7baafbfc3c1808fa801b";

export default node;
